import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Information = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path  fillRule="evenodd" clipRule="evenodd"
            d="M18.5 13.5C18.5 12.6716 19.1716 12 20 12C20.8284 12 21.5 12.6716 21.5 13.5C21.5 14.3284 20.8284 15 20 15C19.1716 15 18.5 14.3284 18.5 13.5Z"
                fill={props.color ? props.color : "white"} />
            <path fillRule="evenodd" clipRule="evenodd"
                d="M36 20C36 28.8366 28.8366 36 20 36C11.1634 36 4 28.8366 4 20C4 11.1634 11.1634 4 20 4C28.8366 4 36 11.1634 36 20ZM20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34ZM20 30C19.4477 30 19 29.5523 19 29L19 18.5C19 17.9477 19.4477 17.5 20 17.5C20.5523 17.5 21 17.9477 21 18.5V29C21 29.5523 20.5523 30 20 30Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Information;
